import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './mdt-anchor.css';

export class MDTAnchor extends PureComponent {
    renderAnchor = () => {
        const {
            disabled,
            className,
            href,
            title,
            target,
            name,
            type,
            onClick,
            download,
            dataTest,
        } = this.props;
        const anchorClassName = classNames(className, 'mdt-anchor');

        if (!disabled) {
            return (
                <a
                    href={href}
                    className={anchorClassName}
                    title={title}
                    target={target}
                    name={name}
                    type={type}
                    onClick={onClick}
                    download={download}
                    data-test={dataTest}
                >
                    {this.props.children}
                </a>
            );
        }
        return (
            <span className={`disabled ${anchorClassName}`} data-test={dataTest}>
                {' '}
                {this.props.children}{' '}
            </span>
        );
    };

    render() {
        return this.renderAnchor();
    }
}

MDTAnchor.propTypes = {
    name: PropTypes.string,
    onClick: PropTypes.func,
    href: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    download: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    dataTest: PropTypes.string,
};

MDTAnchor.defaultProps = {
    name: undefined,
    onClick() {},
    href: undefined,
    target: undefined,
    title: undefined,
    type: undefined,
    download: false,
    disabled: false,
    className: undefined,
    dataTest: 'mdtAnchor',
};

export default MDTAnchor;
